export default "__VITE_ASSET__UpZjibIw__"